import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { updatePassword } from "../../../actions";
import { AuthInput } from "../../../src-new/components/inputs/AuthInput";

const NewPasswordForm = (props) => {
  const { dark } = props;
  const dispatch = useDispatch();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
  const [passwordError, setPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const userData = useSelector(state => state.signupReducer.response);

  const passwordRegex = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,16}$/;

  const handlePassword = (e) => {
    const val = e.target.value;
    setPassword(val);
    if (!val) setPasswordError("Password is required");
    else if (!passwordRegex.test(val)) setPasswordError("Must be 8–16 characters with a number and special character");
    else setPasswordError("");
    if (confirmPassword) setConfirmPasswordError(val === confirmPassword ? "" : "Passwords don't match");
  };

  const handleConfirmPassword = (e) => {
    const val = e.target.value;
    setConfirmPassword(val);
    setConfirmPasswordError(!val ? "Please confirm your password" : val !== password ? "Passwords don't match" : "");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!password) { setPasswordError("Password is required"); return; }
    if (!passwordRegex.test(password)) { setPasswordError("Must be 8–16 characters with a number and special character"); return; }
    if (!confirmPassword) { setConfirmPasswordError("Please confirm your password"); return; }
    if (password !== confirmPassword) { setConfirmPasswordError("Passwords don't match"); return; }
    setIsSubmitting(true);
    // Only show success once the server has actually changed the password.
    const result = await dispatch(updatePassword({
      id: userData?.userId,
      resetToken: userData?.resetToken,
      password: confirmPassword,
    }));
    if (result?.ok) {
      props.setIsPasswordReset(true);
      return;
    }
    setIsSubmitting(false);
    setPasswordError(result?.message || "Could not update the password. Please request a new code and try again.");
  };

  return (
    <>
      <div className="mb-7 text-center">
        <div className="inline-flex items-center justify-center w-12 h-12 rounded-full mb-4" style={dark ? { background: 'rgba(99,102,241,0.2)' } : { background: '#eff6ff' }}>
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" style={dark ? { color: 'rgba(165,180,252,0.9)' } : { color: '#2563eb' }}>
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
          </svg>
        </div>
        <h1 className="text-2xl font-semibold mb-1.5" style={dark ? { color: 'rgba(255,255,255,0.95)' } : { color: '#111827' }}>Create new password</h1>
        <p className="text-sm" style={dark ? { color: 'rgba(255,255,255,0.5)' } : { color: '#6b7280' }}>Your new password must be different from previous ones</p>
      </div>

      <form onSubmit={handleSubmit} noValidate>
        <AuthInput dark={dark} label="New password" isPassword type="password" value={password} onChange={handlePassword} placeholder="8–16 characters" error={passwordError} passwordVisible={passwordVisible} togglePasswordVisibility={() => setPasswordVisible(v => !v)} />
        <AuthInput dark={dark} label="Confirm new password" isPassword type="password" value={confirmPassword} onChange={handleConfirmPassword} placeholder="Re-enter password" error={confirmPasswordError} passwordVisible={confirmPasswordVisible} togglePasswordVisibility={() => setConfirmPasswordVisible(v => !v)} />

        <button
          type="submit"
          disabled={isSubmitting}
          className={`mt-6 w-full py-2.5 px-4 text-white text-sm font-semibold rounded-xl shadow-sm ${dark ? 'auth-btn-primary' : 'bg-blue-600 hover:bg-blue-700 disabled:bg-blue-400 transition-colors duration-150'}`}
        >
          {isSubmitting
            ? <span className="flex items-center justify-center gap-2">
                <svg className="animate-spin w-4 h-4" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
                </svg>
                Saving…
              </span>
            : 'Set new password'
          }
        </button>

        <p className="mt-5 text-center text-sm" style={dark ? { color: 'rgba(255,255,255,0.4)' } : { color: '#6b7280' }}>
          Remember it?{' '}
          <Link to="/signin" className="font-medium" style={dark ? { color: 'rgba(147,197,253,0.9)' } : { color: '#2563eb' }}>Back to sign in</Link>
        </p>
      </form>
    </>
  );
};

export default NewPasswordForm;
